import type { AnyTrackModel } from "../../models/models";
import { brainWaveTracks } from "./brain-waves";
import { cafeTracks } from "./cafes";
import { soundColorTracks } from "./sound-colors";
import { soundscapeTracks } from "./soundscapes";
import { blendedTracks } from "./blends";
import { moodscapeTracks } from "./moodscapes";

export const tracks: AnyTrackModel[] = [
	...blendedTracks,
	...cafeTracks,
	...soundscapeTracks,
	...soundColorTracks,
	...brainWaveTracks,
	...moodscapeTracks,
];
